import { useQuery } from "@tanstack/react-query";
import { cacheOptions, fetchFirebaseData, toList } from "../../../../connector/functions";

const useFirebaseHeroHooks = (l: string) => {
    const profile = useQuery({
        queryKey: ['profile'],
        queryFn: () => fetchFirebaseData(`site/shared/profile`),
        ...cacheOptions,
    });
    const hero = useQuery({
        queryKey: ['hero', l],
        queryFn: () => fetchFirebaseData(`site/${l}/hero`),
        ...cacheOptions,
    });
    const social = useQuery({
        queryKey: ['socialLinks'],
        queryFn: () => fetchFirebaseData(`site/shared/social`),
        ...cacheOptions,
    });

    return {
        nameData: { ...profile, data: profile.data?.name },
        fullNameData: { ...profile, data: profile.data?.fullName },
        textsData: { ...hero, data: toList(hero.data?.professions) },
        descriptionData: { ...hero, data: hero.data?.description },
        greetingData: { ...hero, data: hero.data?.greeting },
        contactButtonData: { ...hero, data: hero.data?.contactButton },
        projectsButtonData: { ...hero, data: hero.data?.projectsButton },
        socialLinksData: social,
    };
}

export default useFirebaseHeroHooks;
